// extracted by mini-css-extract-plugin
export default {"conteneur_video_biographie":"video-biographie_conteneur_video_biographie__o4QHS","embed-container":"video-biographie_embed-container__IK6Kl"};